import { useTranslation } from "react-i18next"
import { SelectionEntity } from "../../Objects/Selection/SelectionEntity"
import { selectionMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"

export const useGetSelection = () => {
  const { t } = useTranslation("general")
  const { enableLoad, disableLoad } = useLoad()
  const { setError } = useError()

  const handleGetSelection = async (onSuccess: any, rote: string = API_ROUTES.SELECTION.GET_ALL) => {
    enableLoad()

    try {
      const response = await GetRequest<SelectionEntity[]>(rote)

      if (response.success) {
        selectionMemory.setList(response.data?.map((ss) => new SelectionEntity(ss)) ?? [])
        onSuccess()
        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleGetSelection }
}
